export class AddressForm extends HTMLElement {
  constructor(data=null) {
    super();
    this.data = data;
  }
  connectedCallback() {
    this.innerHTML =
      `
      <style>
        address-form input, address-form select, .required_field_label {
          margin-bottom: 10px;
        }

        /* Chrome, Safari, Edge, Opera */
        address-form input::-webkit-outer-spin-button,
        address-form input::-webkit-inner-spin-button {
          -webkit-appearance: none;
          margin: 0;
        }

        /* Firefox */
        address-form input[type=number] {
          -moz-appearance: textfield;
        }

        .required_field {
          color: red;
          font-size: 16px;
        }
      </style>
      <div class="row">
        <div class="required_field_label">
          <span>Required field</span>
          <span class="required_field">*</span>
        </div>
        <div class="col-md-6 no-gutters padding_right">
          <label>First Name</label>
          <input type="text" id="address_first_name" class="form-control" placeholder="First Name" value="${this.data && this.data.first_name ? this.data.first_name : ''}">
        </div>
        <div class="col-md-6 no-gutters padding_left">
          <label>Middle Initial</label>
          <input type="text" id="address_middle_initial" class="form-control" placeholder="Middle Initial" value="${this.data && this.data.middle_initial ? this.data.middle_initial : ''}">
        </div>
        <div class="col-md-12 no-gutters">
          <label>Last Name</label>
          <input type="text" id="address_last_name" class="form-control" placeholder="Last Name" value="${this.data && this.data.last_name ? this.data.last_name : ''}">
        </div>
        <div class="col-md-12 no-gutters">
          <label>Title</label>
          <input type="text" id="address_title" class="form-control" placeholder="Title" value="${this.data && this.data.title ? this.data.title : ''}">
        </div>
        <div class="col-md-12 no-gutters">
          <label>Company Name</label>
          <input type="text" id="address_company_name" class="form-control" placeholder="Company Name" value="${this.data && this.data.company_name ? this.data.company_name : ''}">
        </div>
        <div class="col-md-12 no-gutters">
          <label>Address 1</label><span class="required_field"> *</span>
          <input type="text" id="address_street_1" class="form-control" placeholder="Address 1" value="${this.data && this.data.address_1 ? this.data.address_1 : ''}">
        </div>
        <div class="col-md-12 no-gutters">
          <label>Address 2</label>
          <input type="text" id="address_street_2" class="form-control" placeholder="Address 2" value="${this.data && this.data.address_2 ? this.data.address_2 : ''}">
        </div>
        <div class="col-md-12 no-gutters">
          <label>City</label><span class="required_field"> *</span>
          <input type="text" id="address_city" class="form-control" placeholder="City" value="${this.data && this.data.city ? this.data.city : ''}">
        </div>
        <div class="col-md-6 no-gutters padding_right">
          <label>State</label><span class="required_field"> *</span>
          <select id="address_state" class="form-control">
            <option value="null">Select</option>
            <option value="null">U.S.</option>
            <option value="null">-----</option>
            <option value="AL">Alabama</option>
            <option value="AK">Alaska</option>
            <option value="AZ">Arizona</option>
            <option value="AR">Arkansas</option>
            <option value="CA">California</option>
            <option value="CO">Colorado</option>
            <option value="CT">Connecticut</option>
            <option value="DE">Delaware</option>
            <option value="DC">District Of Columbia</option>
            <option value="FL">Florida</option>
            <option value="GA">Georgia</option>
            <option value="HI">Hawaii</option>
            <option value="ID">Idaho</option>
            <option value="IL">Illinois</option>
            <option value="IN">Indiana</option>
            <option value="IA">Iowa</option>
            <option value="KS">Kansas</option>
            <option value="KY">Kentucky</option>
            <option value="LA">Louisiana</option>
            <option value="ME">Maine</option>
            <option value="MD">Maryland</option>
            <option value="MA">Massachusetts</option>
            <option value="MI">Michigan</option>
            <option value="MN">Minnesota</option>
            <option value="MS">Mississippi</option>
            <option value="MO">Missouri</option>
            <option value="MT">Montana</option>
            <option value="NE">Nebraska</option>
            <option value="NV">Nevada</option>
            <option value="NH">New Hampshire</option>
            <option value="NJ">New Jersey</option>
            <option value="NM">New Mexico</option>
            <option value="NY">New York</option>
            <option value="NC">North Carolina</option>
            <option value="ND">North Dakota</option>
            <option value="OH">Ohio</option>
            <option value="OK">Oklahoma</option>
            <option value="OR">Oregon</option>
            <option value="PA">Pennsylvania</option>
            <option value="RI">Rhode Island</option>
            <option value="SC">South Carolina</option>
            <option value="SD">South Dakota</option>
            <option value="TN">Tennessee</option>
            <option value="TX">Texas</option>
            <option value="UT">Utah</option>
            <option value="VT">Vermont</option>
            <option value="VA">Virginia</option>
            <option value="WA">Washington</option>
            <option value="WV">West Virginia</option>
            <option value="WI">Wisconsin</option>
            <option value="WY">Wyoming</option>
            <option value="null">-----</option>
            <option value="null">Canada</option>
            <option value="null">-----</option>
            <option value="AB">Alberta</option>
            <option value="BC">British Columbia</option>
            <option value="MB">Manitoba</option>
            <option value="NB">New Brunswick</option>
            <option value="NL">Newfoundland and Labrador</option>
            <option value="NS">Nova Scotia</option>
            <option value="ON">Ontario</option>
            <option value="PE">Prince Edward Island</option>
            <option value="QC">Quebec</option>
            <option value="SK">Saskatchewan</option>
            <option value="NT">Northwest Territories</option>
            <option value="NU">Nunavut</option>
            <option value="YT">Yukon</option>
          </select>
        </div>
        <div class="col-md-6 no-gutters padding_left">
          <label>Zip Code</label><span class="required_field"> *</span>
          <input type="text" id="address_zip" class="form-control" placeholder="Zip" minlength="5" maxlength="10" value="${this.data && this.data.zip ? this.data.zip : ''}">
        </div>
        <div class="col-md-6 no-gutters padding_right">
          <label>Phone Number</label>
          <input type="text" id="address_phone" class="form-control" placeholder="Phone Number" value="${this.data && this.data.phone ? this.data.phone : ''}">
        </div>
        <div class="col-md-6 no-gutters padding_left">
          <label>Extension</label>
          <input type="number" id="address_extension" class="form-control" placeholder="Extension" value="${this.data && this.data.extension ? this.data.extension : ''}">
        </div>
        <div class="col-md-12 no-gutters">
          <label>Fax Number</label>
          <input type="text" id="address_fax" class="form-control" placeholder="Fax Number" value="${this.data && this.data.fax ? this.data.fax : ''}">
        </div>
        <div class="col-md-12 no-gutters">
          <label>Email</label>
          <input type="text" id="address_email" class="form-control" placeholder="Email" value="${this.data && this.data.email ? this.data.email : ''}">
        </div>
      </div>
      `;

    $(this.querySelector("#address_phone")).mask('(999) 999-9999');
    $(this.querySelector("#address_fax")).mask('(999) 999-9999');
    if(this.data) {
      this.querySelector('#address_state').value = this.data.state;
    }
  }

  validate() {
    let isValid = true;
    let errors = [];
    let validRegex = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?$/i;

    this.querySelectorAll('.error').forEach(elem => {
      elem.classList.remove('error');
    })
    this.querySelectorAll('#address_street_1, #address_city, #address_zip, select').forEach(elem => {
      if(!elem.value || elem.value == "null") {
        elem.classList.add('error');
        errors.push('Make sure all required fields are entered.');
        isValid = false;
      }
    })

    if(this.querySelector('#address_zip').value && this.querySelector('#address_zip').value.length < 5 || this.querySelector('#address_zip').value.length > 10) {
      this.querySelector('#address_zip').classList.add('error');
      errors.push('Zip code must be between 5 and 10 digits.');
      isValid = false;
    }
    if(this.querySelector('#address_zip').value && !parseInt(this.querySelector('#address_zip').value)) {
      this.querySelector('#address_zip').classList.add('error');
      errors.push('Zip code must be a number.');
      isValid = false;
    }
    if(this.querySelector('#address_email').value.trim() != "" && !this.querySelector('#address_email').value.match(validRegex)) {
      this.querySelector('#address_email').classList.add('error');
      errors.push('Please enter a valid email address.');
      isValid = false;
    }
    if(this.querySelector('#address_extension').value && this.querySelector('#address_extension').value.length > 30) {
      this.querySelector('#address_extension').classList.add('error');
      errors.push('Extension must be less than 30 digits.');
      isValid = false;
    }
    
    return {isValid: isValid, errors};
  }

  getData() {
    let data = {
      first_name: this.querySelector('#address_first_name').value,
      middle_initial: this.querySelector('#address_middle_initial').value,
      last_name: this.querySelector('#address_last_name').value,
      title: this.querySelector('#address_title').value,
      company_name: this.querySelector('#address_company_name').value,
      address_1: this.querySelector('#address_street_1').value,
      address_2: this.querySelector('#address_street_2').value,
      city: this.querySelector('#address_city').value,
      state: this.querySelector('#address_state').value,
      zip: this.querySelector('#address_zip').value,
      phone: this.querySelector('#address_phone').value.replace(/\D/g,''),
      extension: this.querySelector('#address_extension').value,
      fax: this.querySelector('#address_fax').value.replace(/\D/g,''),
      email: this.querySelector('#address_email').value
    }

    return data
  }
}

customElements.define('address-form', AddressForm)